import VehicleComparisonDetailItem from "./VehicleComparisonDetailItem";

export default VehicleComparisonDetailItem;
